import * as React from "react";
import {ChildrenType} from "../../_definitions/styleteq";
import SidebarContainer from "../containers/SidebarContainer";
import ContentComponent from "./ContentComponent";
import {currentUserIsLoggedIn} from "../../_helpers/utils";

interface Props {
    children?: ChildrenType;
}

const DashboardComponent = (props: Props) => {
    const {children} = props;

    let stickyDownload;
    if(!currentUserIsLoggedIn())
        stickyDownload = (
            <div className="row panel" style={{ border:'none'}}>
                <div className="large-12 medium-12 columns">
                    <div className="stick-download p1 text-center">
                        <p className="marginless">
                            <h5 className="text-white inline v-align-center">Download the Styleteq App and gain access to the best Grooming Professionals near you & beyond.
                            </h5> <br className="breaking br2" />
                        </p>
                        <a href="https://itunes.apple.com/us/app/styleteq/id1155975962?ls=1&mt=8">
                            <img src={window.Styleteq.images.applePlay} className="inline mr-1 ml-1 store" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.styleteq.app">
                            <img src={window.Styleteq.images.googlePlay} className="inline store" />
                        </a>
                    </div>
                </div>
            </div>
        );

    return (
        <div>
            <div className={!currentUserIsLoggedIn() ? 'off-canvas-wrapper public-view': 'off-canvas-wrapper'}>
                <div id="mainDashboard" className="off-canvas-wrapper-inner">
                    <SidebarContainer/>
                    <ContentComponent children={children}/>
                </div>
            </div>
            {stickyDownload}
        </div>
    );
};

export default DashboardComponent;



// WEBPACK FOOTER //
// ./app/client/dashboard/components/DashboardComponent.tsx